const getWindow = (): IWindow => window as any;

declare global {
  interface IWindow extends Window {
    oetal: {
      config: object;
    };
    cp: object;
  }
}

export { getWindow };
